













import AbpBase from "@/lib/abpbase"
import {Component, Prop, Watch} from "vue-property-decorator"
import {GetDlyRecords, GetPatDlyCancels, GetPatDlyComplications} from "@/api/hd"
import {GetListByCode} from "@/api/configureDictionary"

@Component({
	components: {}
})
export default class XX extends AbpBase {
	@Prop() patient: any
	loading = false
	tableData = []
	type = ''
	columns = [
		{
			title: '终止时间',
			key: 'dlyDate'
		}, {
			title: '终止原因',
			key: 'dlyWay'
		}, {
			title: '描述',
			key: 'dlyCondition'
		}, {
			title: '操作人',
			key: 'creationTime',
		},
	]

	created() {
		this.init()
	}

	private async init() {
		this.loading = true
		let query: any = {
			Type: 0,
			PatientId: this.patient.id
		}
		let res = await GetPatDlyCancels(query)
		this.tableData = res.objects
		this.loading = false
	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisInfo/cancelRecords/index.vue